import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { Oney } from "../../../../../../../components/modules/PaymentMethodsList/containers/Adyen/Oney/components/Oney.js";
const OneyContainer = ({ onChange, options }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("checkout.payment.method.oney.select.title"),
      placeholder: getLabel("checkout.payment.method.oney.select.placeholder")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(Oney, { labels, onChange, options });
};
export {
  OneyContainer
};
//# sourceMappingURL=OneyContainer.js.map
